import { createFileRoute } from '@tanstack/react-router'

import { InputDimensionsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/input-dimensions-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/input-dimensions')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <InputDimensionsDocumentationPage />
    </PermissionChecker>
  ),
})
